module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.hasBmView) ? _c('div', {
    ref: "view",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0faf9690"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-baidu-map/components/map/Map.vue
// module id = 1149
// module chunks = 2